<template>
  <div>
    <div class="Kanit">
      <slot name="header"></slot>

      <div style="max-width: 500px; position: relative" class="mx-auto">
        <div>
          <v-btn @click="query.view = 'Profile'" color="primary" text>
            <v-icon>mdi-chevron-left</v-icon>กลับ</v-btn
          >
        </div>
        <div class="mt-3">
          <div class="px-5">
            <v-card dense class="px-3 py-2"
              ><v-icon>mdi-star</v-icon> เครื่องทั้งหมด :
              <span class="primary--text" style="font-weight: 500">
                {{ numberFormat($store.state.currentPoint) }}
              </span>
            </v-card>
          </div>
        </div>

        <v-row class="mx-0 my-3">
          <v-col cols="auto">
            <PointHistoryFilter v-model="filter" @input="getdata()">
              <template #activator="{ on }">
                <v-btn icon outlined color="primary" v-on="on">
                  <v-icon>filter_list</v-icon>
                </v-btn>
              </template>
            </PointHistoryFilter>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <Export
              :params="{
                tab: ['daily', 'past'][tab],
                memberId: $store.state.member.id,
                ...(filter && {
                  description: filter.search,
                  datefrom: filter.startDate,
                  dateto: filter.endDate,
                }),
              }"
            >
              <template #activator="{ on }">
                <v-btn outlined color="primary" v-on="on">
                  <v-icon>exit_to_app</v-icon>
                  ส่งออก
                </v-btn>
              </template>
            </Export>
          </v-col>
        </v-row>

        <v-tabs
          v-if="!isFilteredWithDate"
          @change="getdata()"
          v-model="tab"
          background-color="#eee"
          dense
          small
          grow
        >
          <v-tab key="daily" value="daily">Today</v-tab>
          <v-tab key="past" value="past">Last 90 days</v-tab>
        </v-tabs>

        <div v-if="loading" class="text-center pt-10">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else class="px-4 pt-2 pb-7">
          <div class="mt-5" v-for="(item, k) in filteredData()" :key="k">
            <div
              class="primary--text"
              style="font-size: small; border-bottom: 1.5px solid #22bef0"
            >
              {{ moment(k).format("DD/MM/YYYY") }}
            </div>
            <div>
              <v-card
                style="min-height: 76px"
                class="my-2 px-3 pt-2"
                v-for="(elem, i) in item"
                :key="i"
              >
                <!-- {{ elem }} -->
                <v-row dense>
                  <v-col cols="8">
                    <div v-if="elem.hasOwnProperty('campaign')">
                      แคมเปญ : {{ elem.campaign }}
                    </div>
                    <div v-else>
                      <div>IMEI : {{ elem.imei }}</div>
                      <div style="font-size: 14px">{{ elem.description }}</div>
                    </div>
                  </v-col>
                  <v-col cols="4" justify-center align-self="center">
                    <div
                      style="
                        font-size: 26px;
                        font-weight: 500;
                        line-height: 12px;
                      "
                      class="primary--text text-center"
                    >
                      <span v-if="elem.points > 0">
                        +{{ numberFormat(elem.points) }}</span
                      >
                      <span v-else>{{ numberFormat(elem.points) }}</span>
                    </div>
                    <div class="text-center ml-2">เครื่อง</div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
          <v-pagination
            v-if="totalPages > 1"
            v-model="result.pagination.page"
            :length="totalPages"
            class="mt-3"
            @input="getdata($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import PointHistoryFilter from "./Filter.vue";
import Export from "./Export.vue";
export default {
  components: {
    PointHistoryFilter,
    Export,
  },
  created() {
    this.$store.state.backgroundColor = "#eee";
  },
  destroyed() {
    this.$store.state.backgroundColor = "#fff";
  },
  mounted() {
    this.getdata();
  },
  computed: {
    moment() {
      return moment;
    },
    isFilteredWithDate() {
      return this.filter && (this.filter.startDate || this.filter.endDate);
    },
    totalPages() {
      const { totalItems, rowsPerPage } = this.result.pagination;
      return Math.ceil(totalItems / rowsPerPage);
    },
  },
  data() {
    return {
      tab: 0,
      loading: false,
      filter: null,
      result: {
        items: [],
        pagination: {
          page: 1,
          rowsPerPage: 10,
          totalItems: 0,
        },
      },
    };
  },
  methods: {
    filteredData() {
      var result;
      if (this.result.items) {
        result = this.result.items.reduce((groups, item) => {
          var objname = moment(item.timestamp).format("YYYY-MM-DD");
          const group = groups[objname] || [];
          group.push(item);
          groups[objname] = group;
          groups[objname].total = groups[objname].total || 0;
          groups[objname].total =
            parseFloat(groups[objname].total) + parseFloat(item.points);
          return groups;
        }, {});

        return result;
      }
    },
    getdata(page = 1) {
      return new Promise((resolve) => {
        this.loading = true;
        axios
          .get(this.serverUrl + "yasale/reward-points-transaction", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              tab: this.tab === 0 ? "daily" : "past",
              memberId: this.$store.state.member.id,
              limit: this.result.pagination.rowsPerPage,
              offset: (page - 1) * this.result.pagination.rowsPerPage,
              ...(this.filter && {
                description: this.filter.search,
                datefrom: this.filter.startDate,
                dateto: this.filter.endDate,
              }),
            },
          })
          .then((response) => {
            this.loading = false;
            if (response.data.responsecode == 200) {
              const [data] = response.data.data;
              const { campaignList, imeiList } = data;

              const totalItems = (() => {
                const campaignTotal = Math.max(
                  ...new Set(campaignList.map((item) => +item.total)),
                  0
                );
                const imeiTotal = Math.max(
                  ...new Set(imeiList.map((item) => +item.total)),
                  0
                );
                return Math.max(campaignTotal, imeiTotal);
              })();

              this.result.items = [...campaignList, ...imeiList];
              this.result.pagination = {
                ...this.result.pagination,
                page,
                totalItems,
              };
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
